import {CaretRightOutlined} from '@ant-design/icons';
import {Collapse, Input, Spin, Switch} from "antd";
import React, {useContext, useEffect, useState} from "react";
import {useDispatch} from 'react-redux';
import {fetchFields, selectFields} from "../../../containers/QueryBuilder/queryBuilderSlice";
import {useAppSelector} from "../../../hooks";
import {isCohortField, LIST} from '../QueryBuilder';
import {QueryBuilderContext, QueryBuilderContextType} from '../QueryBuilderContext';
import {FieldItem} from './FieldItem';
import {FieldItemDraggable} from './FieldItemDraggable';
import styles from './FieldList.module.scss';
import {Field} from "../../../containers/QueryBuilder/types/Field";
import {ReactComponent as DraggableIcon} from '../icons/Draggable-Field.svg';
import {ReactComponent as SelectFieldsIcon} from '../icons/Fields.svg';
import "./FieldList.css";

const {Panel} = Collapse;

const { Search } = Input

export const FieldList = () => {
    const dispatch = useDispatch()
    const fields = useAppSelector(selectFields)
    const [filter, setFilter] = useState<string>("")
    const [draggingId, setDraggingId] = useState<string | undefined>(undefined);
    const [isCategorised, setIsCategorised] = useState(false);

    const {
        isCohortAnalyser,
        dataset
    } = useContext(QueryBuilderContext) as QueryBuilderContextType

    useEffect(() => {
        if (fields === undefined) {
            dispatch(fetchFields())
        }
    }, [dispatch, fields])

    const setIsDragging = (id: string) => {
        setDraggingId(id);
    }

    const setIsNotDragging = (id: string) => {
        if (draggingId === id) {
            setDraggingId(undefined);
        }
    }

    const createDraggableField = (field: Field) => {
        return <FieldItemDraggable key={field.name} id={LIST} field={field} onDrag={setIsDragging} onDragEnd={setIsNotDragging}>
            <FieldItem id={LIST} field={field} />
        </FieldItemDraggable>
    }

    const getFields = () => {
        if (!fields) {
            return <Spin/>
        }
        const displayFields = Object.values(fields)
            .filter(i => i.type === dataset && (!filter || i.name.toLowerCase().includes(filter)))
            .filter(i => !isCohortField(i.code) || (isCohortField(i.code) && isCohortAnalyser));

        if (!isCategorised) {
            return displayFields.map(createDraggableField);
        }

        const parents = displayFields.reduce((parentDescriptionsArray: any[], visibleField) => {
            const parentDescription = visibleField.parentDescription;
            const parentRank = visibleField.parentRank;
            const parent = {parentDescription, parentRank};
            if (parentDescriptionsArray.length === 0) {
                parentDescriptionsArray.push(parent);
                return parentDescriptionsArray;
            }
            const isNewParent = parentDescriptionsArray.findIndex((parent:any) => {
                return parent.parentDescription === parentDescription
            }) === -1;
            if (isNewParent) {
                parentDescriptionsArray.push(parent)
            }
            return parentDescriptionsArray;
        } , [])
            .sort((parent1:any, parent2:any) => parent1.parentRank > parent2.parentRank ? 1 : -1);

        const openPanelsOnSearchText = filter.length <= 1 ? [] : parents.map(parent => parent.parentDescription);

        return <Collapse
            key={filter}
            expandIconPosition={"end"}
            expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} />}
            className="fieldlist-custom-collapse"
            bordered={false}
            defaultActiveKey={openPanelsOnSearchText}
        >
            {parents.map(parent => {
                const displayFieldsForParent = displayFields.filter((field) => field.parentDescription === parent.parentDescription);
                const fieldElements = displayFieldsForParent.map(createDraggableField);
                return <Panel header={parent.parentDescription} key={parent.parentDescription} className="fieldlist-custom-panel">
                    {fieldElements}
                </Panel>
            })}
        </Collapse>
    }

    return <div className={styles.container}>
        <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
            <div
                className={styles.header}
                style={{ display: 'flex', alignItems: 'center', width: '100%' }}
            >
                <SelectFieldsIcon style={{ marginRight: 6, paddingTop: 2 }} />
                <span>Fields</span>

                <Switch
                    style={{ marginLeft: 'auto' }}
                    checkedChildren="Categorised"
                    unCheckedChildren="Uncategorised"
                    checked={isCategorised}
                    onChange={(checked) => setIsCategorised(checked)}
                />
            </div>
        </div>
        <Search className={styles.search} allowClear placeholder="Search..." onChange={event => setFilter(event.target.value.toLowerCase())} onSearch={value => setFilter(value.toLowerCase())} />
        <div className={styles.draggable_header}><DraggableIcon style={{marginLeft: '4px', paddingLeft:'5px'}}/>&nbsp;&nbsp;Draggable Fields </div>
        <div className={draggingId ? styles.list + " " + styles.list_with_dragging : styles.list}>
            {getFields()}
        </div>
    </div>
}